
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/articles/[page]",
      function () {
        return require("private-next-pages/blog/articles/[page].tsx");
      }
    ]);
  